export default __webpack_public_path__ + "static/media/pow-2-med.a8c6bb1e.jpg";